import {
  collection,
  doc,
  getDoc,
  getDocs,
  limit,
  orderBy,
  query,
  startAfter,
  where,
} from 'firebase/firestore';
import { db } from '../lib/firebase';

const PAGE_SIZE = 10;

export function mapSale(snap) {
  return { id: snap.id, ...snap.data() };
}

/**
 * Ventas = colección `pedidos` (no existe una colección `ventas`).
 * Mismo criterio que PedidosScreen: ruc + cancelado==false + orderBy pedido desc.
 */
export async function listSales({ ruc, pageSize = PAGE_SIZE, cursor = null, search = '', includeCancelled = false }) {
  if (!ruc) throw new Error('RUC requerido');

  const constraints = [where('ruc', '==', ruc)];
  if (!includeCancelled) constraints.push(where('cancelado', '==', false));

  if (search) {
    const term = search.trim().toLowerCase();
    const q = query(collection(db, 'pedidos'), ...constraints, orderBy('pedido', 'desc'), limit(pageSize * 3));
    const snap = await getDocs(q);
    const items = snap.docs
      .map(mapSale)
      .filter((p) => {
        const cliente = String(p.clienteNombre || p.cliente || '').toLowerCase();
        const num = String(p.pedido ?? '');
        return cliente.includes(term) || num.includes(term);
      })
      .slice(0, pageSize);
    return { items, cursor: null, hasMore: false };
  }

  const q = cursor
    ? query(collection(db, 'pedidos'), ...constraints, orderBy('pedido', 'desc'), startAfter(cursor), limit(pageSize))
    : query(collection(db, 'pedidos'), ...constraints, orderBy('pedido', 'desc'), limit(pageSize));

  const snap = await getDocs(q);
  const last = snap.docs[snap.docs.length - 1] || null;
  return {
    items: snap.docs.map(mapSale),
    cursor: last,
    hasMore: snap.docs.length === pageSize,
  };
}

export async function getSale(id) {
  const snap = await getDoc(doc(db, 'pedidos', id));
  if (!snap.exists()) throw new Error('Venta no encontrada');
  return mapSale(snap);
}
